module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (257).5aa4f917.jpg";